<div *ngIf="!applyToMode; else applyToModeTemplate"
     class="bg-secondary border rounded">
  <div class="m-3">
    <div class="fw-semibold mb-2">
      {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.applyToTitle' | i18next }}
    </div>
    <div>
      {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.applyToInfo' | i18next: { value: totalCount} }}
    </div>

  </div>
</div>

<div [class]="!applyToMode ? 'bg-secondary border rounded mt-3' : ''">
  <mbs-utility-alert-summary [profileMode]="applyToMode"
                             [providerEmail]="providerEmail">
  </mbs-utility-alert-summary>
</div>

<div *ngIf="showProvider || showEmailRecipients || showPushRecipients "
     class="bg-secondary border rounded mt-3">
  <div>

    <div *ngIf="showProvider">
      <div class="fw-semibold m-3">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.notifyProvider' | i18next }}
      </div>
      <div class="m-3">
        {{ providerEmail }}
      </div>
    </div>

    <div *ngIf="showEmailRecipients">
      <hr *ngIf="showProvider">
      <div class="fw-semibold m-3">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.notifyUsers' | i18next }}
      </div>
      <div class="m-3">
        {{ resultInfo?.recipient?.emails.join(', ') }}
      </div>
    </div>

    <div *ngIf="showPushRecipients">
      <hr *ngIf="showProvider || showEmailRecipients">
      <div class="fw-semibold m-3">
        {{ 'mbs-ui:rmm-custom-alerting.wizard.lastStep.sendPush' | i18next }}
      </div>
      <div class="m-3">
        {{ !!pushRecipientNames ? pushRecipientNames : ('shared:validation.noAdministrator' | i18next) }}
      </div>
    </div>

  </div>
</div>


<ng-template #applyToModeTemplate>
  <div *ngIf="profileInfo">
    <div class="bg-secondary border rounded mb-3">
      <div class="m-3">
        <div class="fw-semibold mb-2">
          {{ 'mbs-ui:rmm-custom-alerting.newProfileName' | i18next }}
        </div>
        <div class="mb-2">
          {{ profileInfo?.name }}
        </div>
      </div>
    </div>

    <div class="bg-secondary border rounded mb-3">
      <div class="m-3">
        <h5 class="m-0">{{ 'shared:rmm.groupActions.stepResult.taskApplyTo' | i18next }}</h5>
        <div>
          {{ profileInfo?.applyTo?.includeInfo }}
        </div>
      </div>

      <div *ngIf="profileInfo?.applyTo?.tags?.length"
           class="m-3">
        <h5 class="m-0">{{ 'mbs-ui:rmm-custom-alerting.applyTags' | i18next }}</h5>
        <div>
          <span *ngFor="let tag of profileInfo.applyTo.tags; last as last">
            <span *ngIf="(getTagById(tag) | async)?.name as tagName; else deletedTag">{{ tagName }}</span>
            <span>{{ last ? '' : ', ' }}</span>
            <ng-template #deletedTag>
              <span class="fa fa-ban text-danger"></span>
              <span class="text-danger ml-1">{{ 'shared:rmm-group-task.removedTagName' | i18next: { value: tag }
                }}</span>
            </ng-template>
          </span>
        </div>
      </div>

      <div *ngIf="profileInfo?.applyTo?.excludeInfo"
           class="m-3">
        <h5 class="m-0">{{ 'mbs-ui:rmm-custom-alerting.excludeComputersTitle' | i18next }}</h5>
        <div>
          {{ profileInfo?.applyTo?.excludeInfo }}
        </div>
      </div>
    </div>
  </div>


</ng-template>
